import { getApiUrl } from './apiConfig';

export async function fetchExerciseRoutines(studentId) {
  const res = await fetch(
    `${getApiUrl()}/api/exercise-routines?student_id=${encodeURIComponent(String(studentId))}`
  );
  if (!res.ok) throw new Error('Failed to load routines');
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function fetchSharedExerciseRoutines(studentId) {
  const res = await fetch(
    `${getApiUrl()}/api/exercise-routines/shared?student_id=${encodeURIComponent(String(studentId))}`
  );
  if (!res.ok) throw new Error('Failed to load shared routines');
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function fetchRoutineItems(routineId, { accessStudentId } = {}) {
  const qs =
    accessStudentId != null
      ? `?access_student_id=${encodeURIComponent(String(accessStudentId))}`
      : '';
  const res = await fetch(
    `${getApiUrl()}/api/exercise-routines/${encodeURIComponent(String(routineId))}/items${qs}`
  );
  if (!res.ok) throw new Error('Failed to load routine exercises');
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function createExerciseRoutine({ studentId, name, description }) {
  const res = await fetch(`${getApiUrl()}/api/exercise-routines`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      student_id: studentId,
      name: String(name).trim(),
      description: description ?? null,
    }),
  });
  if (!res.ok) throw new Error('Failed to create routine');
  return res.json();
}

export async function batchUpdateRoutineNames(updates, ownerStudentId) {
  const res = await fetch(`${getApiUrl()}/api/exercise-routines/batch-update-names`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates, owner_student_id: ownerStudentId }),
  });
  if (!res.ok) throw new Error('Failed to update routine names');
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function batchDeleteRoutines(ids, ownerStudentId) {
  const res = await fetch(`${getApiUrl()}/api/exercise-routines/batch-delete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids, owner_student_id: ownerStudentId }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to delete routines');
  }
  return res.json();
}

export async function updateExerciseRoutine(id, { name, description, ownerStudentId }) {
  const res = await fetch(`${getApiUrl()}/api/exercise-routines/${encodeURIComponent(String(id))}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: String(name).trim(),
      description: description ?? null,
      owner_student_id: ownerStudentId,
    }),
  });
  if (!res.ok) throw new Error('Failed to update routine');
  return res.json();
}

export async function syncRoutineItems(routineId, items, ownerStudentId) {
  const res = await fetch(
    `${getApiUrl()}/api/exercise-routines/${encodeURIComponent(String(routineId))}/items`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items, owner_student_id: ownerStudentId }),
    }
  );
  if (!res.ok) throw new Error('Failed to save routine exercises');
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function shareExerciseRoutine({
  routineId,
  sharedWithStudentId,
  sharedByStudentId,
}) {
  const res = await fetch(
    `${getApiUrl()}/api/exercise-routines/${encodeURIComponent(String(routineId))}/share`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shared_with_student_id: sharedWithStudentId,
        shared_by_student_id: sharedByStudentId,
      }),
    }
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Failed to share routine');
  }
  return data;
}

export async function cloneExerciseRoutine({ routineId, studentId, name }) {
  const res = await fetch(
    `${getApiUrl()}/api/exercise-routines/${encodeURIComponent(String(routineId))}/clone`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ student_id: studentId, name }),
    }
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Failed to clone routine');
  }
  return data;
}
